Drupal.behaviors.convertTopLevelMenuItemsToHeadings = {
  attach: function () {
    const topLevelMenuItems = document.querySelectorAll(
      ".menu__item--lvl1 > a"
    );

    topLevelMenuItems.forEach((item) => {
      // Create an h3 element
      const h3 = document.createElement("h3");

      // Transfer the content from the 'a' tag to the 'h3' tag
      h3.innerHTML = item.innerHTML;

      // Replace the 'a' tag with the 'h3' tag
      item.parentNode.replaceChild(h3, item);
    });
  },
};
